<template>
  <app-page
    :title="employee ? $t('employee.invite.title', { name: employee.full_name }) : $t('employee.invite.titleFallback')"
    :error="error"
    :previous="[
      { label: $t('employee.previousLabel'), to: { name: 'employees' } },
      {
        label: employee ? employee.full_name : $t('employee.title'),
        to: { name: 'employee', params: { employeeId: $route.params.employeeId } },
      },
    ]"
    icon="envelope"
  >
    <app-loading :loading="loading" />
    <template v-if="!loading && !saved">
      <sme-alert level="warning">
        {{ $t('employee.invite.warningAlert', { name: employee.full_name }) }}
      </sme-alert>
      <page-sub-footer>
        <b-button @click="invite" variant="primary" :disabled="saving || saved">
          <b-spinner v-if="saving" class="mr-2" small />
          {{ saving ? $t('employee.invite.sendingButton') : $t('employee.invite.sendButton') }}
        </b-button>
      </page-sub-footer>
    </template>
    <sme-alert v-if="saved" level="good">
      <i18n path="employee.invite.successAlert" tag="span">
        <template #email
          ><strong>{{ employee.work_email }}</strong></template
        >
      </i18n>
    </sme-alert>
  </app-page>
</template>

<script>
import ApiClient from '@/ApiClient';
import AppLoading from '@/components/AppLoading.vue';
import AppPage from '@/components/AppPage.vue';
import PageSubFooter from '@/components/PageSubFooter.vue';
import SmeAlert from '@/components/atoms/SmeAlert.vue';
import i18n from '@/i18n';

export default {
  name: 'EmployeeInvite',
  components: { AppLoading, AppPage, PageSubFooter, SmeAlert },
  data() {
    return {
      loading: true,
      saving: false,
      saved: false,
      error: undefined,
      employee: undefined,
    };
  },
  methods: {
    invite() {
      this.saving = true;

      ApiClient.employeeInvite(this.employee.employee_id).then(
        data => {
          if (data.employee_invited) {
            this.saving = false;
            this.saved = true;
          } else {
            this.error = i18n.t('employee.invite.inviteError', { name: this.employee.full_name });
            this.loading = false;
          }
        },
        error => {
          this.error = error.message;
          this.loading = false;
        },
      );
    },
    loadData() {
      this.loading = true;
      ApiClient.getEmployee(this.$route.params.employeeId).then(
        employee => {
          this.employee = employee;
          this.loading = false;
        },
        error => {
          this.error = error.message;
          this.loading = false;
        },
      );
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
